import { render, staticRenderFns } from "./DayBlock.vue?vue&type=template&id=a3aa3f8c&scoped=true&"
import script from "./DayBlock.vue?vue&type=script&lang=js&"
export * from "./DayBlock.vue?vue&type=script&lang=js&"
import style0 from "./DayBlock.vue?vue&type=style&index=0&id=a3aa3f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aa3f8c",
  null
  
)

export default component.exports